import { render, staticRenderFns } from "./ConfigTable.vue?vue&type=template&id=d4627e2a&"
import script from "./ConfigTable.vue?vue&type=script&lang=js&"
export * from "./ConfigTable.vue?vue&type=script&lang=js&"
import style0 from "./ConfigTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports